export const permissionsKeys = {
  page: 'micro-sites.regulations.page-block',
  pageBlockFind: 'micro-sites.regulations.page-block.find',
  pageBlockCreateDefault: 'micro-sites.regulations.page-block.createDefault',
  pageBlockUpdate: 'micro-sites.regulations.page-block.update',
  pageBlockPreview: 'micro-sites.regulations.page-block.preview',
  pageBlockUpdateInactivate: 'micro-sites.regulations.inactivate.page-block.update',
  pageBlockUpdateActive: 'micro-sites.regulations.active.page-block.update',
  pageBlockRemove: 'micro-sites.regulations.page-block.remove',
};
